"use client";

import { c as _c } from "react/compiler-runtime";
import { swapAggConfigAtom } from "@/config/atoms/swapAggConfigAtom";
import { cn, Input, Popover, PopoverContent, PopoverTrigger, Slider } from "@heroui/react";
import { useAtom } from "jotai";
import { Settings2 } from "lucide-react";
export default function AggSettingsPopover() {
  const $ = _c(29);
  const [aggConfigAtom, setAggConfigAtom] = useAtom(swapAggConfigAtom);
  let t0;
  if ($[0] !== setAggConfigAtom) {
    t0 = value => {
      setAggConfigAtom(prevConfig => ({
        ...prevConfig,
        slippageTolerance: value
      }));
    };
    $[0] = setAggConfigAtom;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleSlippageChange = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["before:farm-popover"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      base: t1,
      content: ["py-3 px-4 border border-default-200", cn("farm-popover")]
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PopoverTrigger className="cursor-pointer"><Settings2 width={30} /></PopoverTrigger>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h3 className="text-lg font-bold text-center pb-4">Swap Aggregator Settings</h3>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== setAggConfigAtom) {
    t5 = e => setAggConfigAtom(prevConfig_0 => ({
      ...prevConfig_0,
      maxHops: e as 1 | 2 | 3 | 4
    }));
    $[6] = setAggConfigAtom;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== aggConfigAtom.maxHops || $[9] !== t5) {
    t6 = <Slider className="min-w-2.5" color="foreground" defaultValue={aggConfigAtom.maxHops} onChange={t5} label="Max Hops" maxValue={4} minValue={1} showSteps={true} showTooltip={true} size="sm" step={1} />;
    $[8] = aggConfigAtom.maxHops;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleSlippageChange) {
    t7 = value_0 => handleSlippageChange(value_0 as number);
    $[11] = handleSlippageChange;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== aggConfigAtom.slippageTolerance || $[14] !== t7) {
    t8 = <Slider className="max-w-md min-w-fit" color="foreground" label="Slippage Tolerance" value={aggConfigAtom.slippageTolerance} onChange={t7} maxValue={10} minValue={0.1} step={0.1} showTooltip={true} hideValue={true} size="sm" />;
    $[13] = aggConfigAtom.slippageTolerance;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== aggConfigAtom.slippageTolerance) {
    t9 = aggConfigAtom.slippageTolerance.toString();
    $[16] = aggConfigAtom.slippageTolerance;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== handleSlippageChange) {
    t10 = e_0 => handleSlippageChange(Number.parseFloat(e_0.target.value));
    $[18] = handleSlippageChange;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <Input type="number" value={t9} onChange={t10} size="sm" className="w-[100px]" endContent="%" />;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t8) {
    t12 = <div className="flex items-center space-x-2">{t8}{t11}</div>;
    $[23] = t11;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t6) {
    t13 = <Popover showArrow={true} classNames={t2}>{t3}<PopoverContent><div className="p-4">{t4}<div className="flex flex-col space-y-6">{t6}{t12}</div></div></PopoverContent></Popover>;
    $[26] = t12;
    $[27] = t6;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}